// extracted by mini-css-extract-plugin
module.exports = {"container":"SafePhone_container_1rYui","goBack":"SafePhone_goBack_1cd6-"};